var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.classes,attrs:{"type":"date"},domProps:{"value":_vm.inner},on:{"input":_vm.doInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }